/**
 * 相对父级颜色转换方法
 */
var ColorConvertMode;
(function (ColorConvertMode) {
    /**
     * generate Color Gradation, arg from step1 to step10
     */
    ColorConvertMode["colorPalette"] = "colorPalette";
    /**
     * arg from 0 to 1
     */
    ColorConvertMode["fade"] = "fade";
    /**
     * Mix the color with pure white, arg from 0 to 100.
     */
    ColorConvertMode["tint"] = "tint";
    /**
     * Mix the color with pure black, from 0 to 100.
     */
    ColorConvertMode["shade"] = "shade";
})(ColorConvertMode || (ColorConvertMode = {}));
/**
 * 颜色色阶的索引
 */
var ColorGradationStep;
(function (ColorGradationStep) {
    ColorGradationStep["step1"] = "step1";
    ColorGradationStep["step2"] = "step2";
    ColorGradationStep["step3"] = "step3";
    ColorGradationStep["step4"] = "step4";
    ColorGradationStep["step5"] = "step5";
    ColorGradationStep["step6"] = "step6";
    ColorGradationStep["step7"] = "step7";
    ColorGradationStep["step8"] = "step8";
    ColorGradationStep["step9"] = "step9";
    ColorGradationStep["step10"] = "step10";
})(ColorGradationStep || (ColorGradationStep = {}));
export { ColorConvertMode, ColorGradationStep, };
